import {
    AgentSkillsView,
    AgentSkillsViewColumn,
} from "@common/types/views/agentSkillsView";
import { ViewDensity, ViewType } from "@common/types/views/views";

export const defaultAgentSkillsView: AgentSkillsView = {
    type: ViewType.AGENT_SKILLS,
    columns: [
        { id: AgentSkillsViewColumn.TITLE, options: { pin: "left" } },
        { id: AgentSkillsViewColumn.DESCRIPTION },
        { id: AgentSkillsViewColumn.CATEGORY },
        { id: AgentSkillsViewColumn.CREATED_BY },
        { id: AgentSkillsViewColumn.LOAD_MODE },
        { id: AgentSkillsViewColumn.ACTIONS, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: false,
        bulkActions: false,
        density: ViewDensity.MD,
    },
};
